const playerSelector = '.js-video-popup';

export class VideoPopup {
  static isOnPage() {
    return $(playerSelector).length !== 0;
  }

  constructor() {
    this.load();
    this.init();
  }

  load() {
    /**
     * JW Player support for magnific popup
     */

    const currentJwplayer = {
      player: null,
      playerElement: null,
      playerId: 'mfp-jwplayer-instance',
      pendingConfig: null,

      setCurrentPlayer(player) {
        this.player = player;
      },

      setCurrentPlayerElement(playerElement) {
        this.playerElement = playerElement;
      },

      getCurrentPlayer() {
        return this.player;
      },

      getCurrentPlayerElement() {
        return this.playerElement;
      },

      reset() {
        this.player = null;
        this.playerElement = null;
        this.pendingConfig = null;
      }
    };

    const getCloseModalAriaLabel = () => {
      const videoObj = $('.js-video-popup');
      if (videoObj.length > 0) {
        const ariaLabel = videoObj.data('close-aria-label');

        return ariaLabel || 'Close';
      }

      return 'Close';
    };

    const closeBtnAriaLabel = getCloseModalAriaLabel();

    $.magnificPopup.registerModule('jwplayer', {
      options: {
        markup:
          '<div class="mfp-jw-wrapper">' +
          '<button type="button" aria-label="' + closeBtnAriaLabel + '" class="mfp-close">&times;</button>' +
          '<div id="mfp-jwplayer"></div>' +
          '</div>'
      },

      proto: {
        initJwplayer() {
          // Initialize event handlers
        },

        hideOriginalButton(element) {
          currentJwplayer.setCurrentPlayerElement(element);
          if (element) {
            element.style.display = 'none';
          }
        },

        instantiatePlayer() {
          const element = currentJwplayer.getCurrentPlayerElement();
          if (!element) {
            return;
          }

          const urlHls = element.getAttribute('data-video-url-hls');
          const urlProgressive = element.getAttribute('data-video-url-progressive') || element.getAttribute('href');
          const videoName = element.getAttribute('data-video-title') || element.getAttribute('data-video-name') || 'Video';

          currentJwplayer.pendingConfig = {
            playlist: [{
              file: urlHls || urlProgressive,
              title: videoName
            }],
            autostart: true,
            ga4analytics: true,
            controls: true,
            mute: false
          };
        },

        appendPlayerToPopup() {
          if (!currentJwplayer.pendingConfig) {
            return;
          }

          const checkInterval = setInterval(() => {
            const mfpPlayerWrapper = document.querySelector('#mfp-jwplayer');

            if (mfpPlayerWrapper) {
              clearInterval(checkInterval);

              while (mfpPlayerWrapper.firstChild) {
                mfpPlayerWrapper.removeChild(mfpPlayerWrapper.firstChild);
              }

              const existing = document.getElementById(currentJwplayer.playerId);
              if (existing) {
                existing.remove();
              }

              const playerContainer = document.createElement('div');
              playerContainer.id = currentJwplayer.playerId;

              const originalEl = currentJwplayer.getCurrentPlayerElement();
              if(originalEl) {
                  const videoTitle = originalEl.getAttribute('data-video-title') || 'Video';
                  playerContainer.setAttribute('aria-label', videoTitle);
                  playerContainer.setAttribute('role', 'presentation');
              }

              mfpPlayerWrapper.appendChild(playerContainer);

              if (typeof window.setupVideoPlayer === 'function') {
                try {
                  const player = window.setupVideoPlayer(currentJwplayer.playerId, currentJwplayer.pendingConfig);
                  currentJwplayer.setCurrentPlayer(player);
                } catch (error) {
                  // Silent error handling
                }
              }
            }
          }, 50);

          setTimeout(() => {
            clearInterval(checkInterval);
          }, 5000);
        },

        getJwplayer(item, template) {
          const that = this;
          this.updateStatus('ready');
          let isDone = false;
          let clickedElement = null;

          const magnificPopupSetup = (e) => {
            if (!isDone) {
              try {
                if (e.type === 'mfpOpen' && item.el && item.el[0]) {
                  clickedElement = item.el[0];
                }

                if (clickedElement) {
                  that.hideOriginalButton(clickedElement);
                  that.instantiatePlayer();
                  that.appendPlayerToPopup();
                  isDone = true;
                }
              } catch (error) {
                // Silent error handling
              }
            }
          };

          this.ev.on('mfpOpen', magnificPopupSetup);
          this.ev.on('mfpChange', magnificPopupSetup);

          this.ev.on('mfpClose', () => {
            try {
              if (currentJwplayer.getCurrentPlayer()) {
                currentJwplayer.getCurrentPlayer().remove();
              }
            } catch (e) {
              // Silent error handling
            } finally {
              const originalElement = currentJwplayer.getCurrentPlayerElement();
              if (originalElement) {
                originalElement.style.display = '';
              }

              currentJwplayer.reset();
              isDone = false;
              clickedElement = null;
            }
          });

          return template;
        }
      }
    });

    const uglyJwplayerWrapperHack = () => {
      const videoObj = $('.js-video-popup');
      const jwChildWithPop = videoObj.find($('.js-video-popup'));
      if (jwChildWithPop.length > 0) {
        jwChildWithPop.removeClass('js-video-popup');
      }
    };

    uglyJwplayerWrapperHack();
  }

  init() {
    $.each($(playerSelector), (index, player) => {
      if ($(player).parents('.image-carousel').length === 0) {
        const $player = $(player);
        const videoUrl = $player?.data('youtube-url') || $player?.attr('href');
        const isYouTube = $player.hasClass('js-video-youtube');
        let config;

        if (isYouTube) {
        config = {
          items: {
            src: videoUrl
          },
          type: 'iframe',
          iframe: {
            patterns: {
              youtube: {
                index: 'youtube.com/',
                // Regex is required to extract the unique 11-character YouTube video ID
                // from various URL formats (watch?v=, youtu.be/, embed/) and to
                // strip away extra parameters like timestamps (&t=) or tracking tags.
                id: (url) => {
                  const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
                  const match = url.match(regExp);

                  return (match && match[7] && match[7].length === 11)
                    ? match[7]
                    : url;
                },
                src: 'https://www.youtube.com/embed/%id%?autoplay=1'
              }
            }
          }
        };
      } else {
          config = {
            type: 'jwplayer',
            closeOnContentClick: false,
            closeBtnInside: true
          };
        }

        $player.on('keydown', (event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            $player.magnificPopup('open');
          }
        });

        $player.magnificPopup(config);
      }
    });
  }
}